module.exports = __webpack_public_path__ + "static/img/store-active.ce79f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/store-active.png
// module id = ICOI
// module chunks = 58